import React from 'react';
import PropTypes from 'prop-types';

import { StyledStatus } from './StyledComponents';

const ConnectedStatus = (props) => {
    const { message, type, size } = props;

    return (
        <StyledStatus className="ConnectedStatus" data-test="connected-status" type={type} size={size}>
            <div className="ConnectedStatus-StatusText" data-test="connected-status-text">
                {message}
            </div>
        </StyledStatus>
    );
};

ConnectedStatus.propTypes = {
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
        'info',
        'neutral',
        'success',
        'warn',
        'in_progress',
        'caution',
    ]).isRequired,
    size: PropTypes.oneOf(['sm', 'md']),
};

ConnectedStatus.defaultProps = {
    size: 'md',
};

export default ConnectedStatus;
